<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/cooperativePriceList' }">合作价格</el-breadcrumb-item>
                <el-breadcrumb-item>合作价格{{type == '1' ? '编辑' : '新增',}}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <el-button size="small" plain @click="submitDetailsData('ruleDetailsForm')" :loading="btnLoading">保存</el-button>
                    <el-button size="small" plain @click="cancel">取消</el-button>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form :model="ruleForm" :rules="rules" ref="ruleDetailsForm" :label-position="labelPosition" class="details">
                        <el-form-item label="code：" prop="code" v-if="type == 1">
                            <el-input v-model="ruleForm.code" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                        </el-form-item>
                        <el-form-item label="合作方：" prop="partner_name" v-if="type == 1">
                            <el-input v-model="ruleForm.partner_name" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                        </el-form-item>
                        <el-form-item label="产品：" prop="product_name" v-if="type == 1">
                            <el-input v-model="ruleForm.product_name" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                        </el-form-item>
                        <el-form-item label="产品代码：" prop="product_code" v-if="type == 1">
                            <div class="read_only_link read_only" @click="productClick(ruleForm.product_rid)">
                                {{ ruleForm.product_code }}
                            </div>
                        </el-form-item>
                        <el-form-item label="省份：" prop="province_name" v-if="type == 1">
                            <el-input v-model="ruleForm.province_name" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                        </el-form-item>
                        <el-form-item label="城市：" prop="city_name" v-if="type == 1">
                            <el-input v-model="ruleForm.city_name" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                        </el-form-item>
                        <el-form-item label="特征码：" prop="feature_code" v-if="type == 1">
                            <el-input v-model="ruleForm.feature_code" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                        </el-form-item>
                        <el-form-item label="开始时间：" prop="start_date">
                            <el-date-picker
                                v-model="ruleForm.start_date"
                                type="date"
                                placeholder="请选择开始时间"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                                size="mini"
                                @change="startChange"
                                clearable
                            >
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="结束时间：" prop="end_date">
                            <el-date-picker
                                v-model="ruleForm.end_date"
                                type="date"
                                placeholder="请选择结束时间"
                                format="yyyy-MM-dd"
                                size="mini"
                                value-format="yyyy-MM-dd"
                                @change="endDate"
                                clearable
                            >
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="需方：" prop="demander_name">
                            <el-select
                                v-model="ruleForm.demander_name"
                                filterable
                                remote
                                reserve-keyword
                                placeholder="请输入需方搜索"
                                :remote-method="remotePartner"
                                :loading="partnerLoading"
                                size="mini"
                                clearable
                                @change="partnerChange"
                            >
                                <el-option v-for="item in partnerOptions" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="时效性：" prop="timeliness" v-if="type == 1">
                            <el-input v-model="ruleForm.timeliness_label" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                        </el-form-item>
                        <el-form-item label="审批状态：" prop="approval_status" v-if="type == 1">
                            <el-input
                                v-model="ruleForm.approval_status_label"
                                class="flex_item_text"
                                size="mini"
                                readonly="readonly"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="发票单价：" prop="unit_invoice_price">
                            <el-input
                                v-model="ruleForm.unit_invoice_price"
                                size="mini"
                                placeholder="请输入发票单价"
                                type="number"
                                :min="0"
                                clearable
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="单位限额：" prop="unit_marginal_expense_quota">
                            <el-input
                                v-model="ruleForm.unit_marginal_expense_quota"
                                size="mini"
                                placeholder="请输入单位限额"
                                type="number"
                                :min="0"
                                clearable
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="上次提交人职位：" prop="submission_hierarchy_name" v-if="type == 1">
                            <el-input
                                v-model="ruleForm.submission_hierarchy_name"
                                size="mini"
                                class="flex_item_text"
                                readonly="readonly"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="MEPR：" prop="MEPR" v-if="type == 1">
                            <el-input
                                v-model="ruleForm.marginal_expense_provision_rate"
                                size="mini"
                                class="flex_item_text"
                                readonly="readonly"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="提交人职位：" prop="submission_hierarchy_rid">
                            <el-select
                                v-model="ruleForm.submission_hierarchy_rid"
                                placeholder="请选择职位等级"
                                clearable
                                style="width: 100%"
                                filterable
                            >
                                <el-option v-for="item in hierarchyOptions" :key="item.value" :label="item.name" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="VATR：" prop="VATR" v-if="type == 1">
                            <el-input
                                v-model="ruleForm.value_added_tax_rate"
                                size="mini"
                                class="flex_item_text"
                                readonly="readonly"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="单位底价：" prop="unit_base_price" v-if="type == 1">
                            <el-input v-model="ruleForm.unit_base_price" size="mini" class="flex_item_text" readonly="readonly"></el-input>
                        </el-form-item>
                        <el-form-item label="合作规划code：" prop="partner_scheme_rid">
                            <el-select
                                v-model="ruleForm.partner_scheme_rid"
                                placeholder="请选择合作规划code"
                                clearable
                                filterable
                                size="mini"
                            >
                                <el-option v-for="item in partnerSchemeOptions" :key="item.rid" :label="item.code" :value="item.rid">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="创建人：" prop="created_by" v-if="type == 1">
                            <div class="read_only">
                                {{ ruleForm.created_by ? ruleForm.created_by : '' }}
                            </div>
                        </el-form-item>
                        <el-form-item label="上次修改人：" prop="updated_by" v-if="type == 1">
                            <div class="read_only">
                                {{ ruleForm.updated_by ? ruleForm.updated_by : '' }}
                            </div>
                        </el-form-item>
                    </el-form>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
export default {
    name: 'cooperativePriceEdit',
    data() {
        return {
            partnerLoading: false,
            partnerOptions: [], //需方列表
            partnerSchemeOptions: [], //合作规划code列表
            rid: '',
            title: '', //新增或编辑
            type: '', //1  编辑 2 新增
            activeNames: ['1'],
            labelPosition: 'right',
            //基本信息内表单验证
            ruleForm: {
                code: '',
                partner_rid: '',
                partner_name: '',
                product_rid: '',
                product_name: '',
                product_code: '',
                city_rid: '',
                city_name: '',
                province_rid: '',
                province_name: '',
                feature_code: '',
                start_date: '',
                end_date: '',
                timeliness: '',
                timeliness_label: '',
                approval_status_label: '',
                marginal_expense_provision_rate: '',
                value_added_tax_rate: '',
                demander_rid: '',
                unit_invoice_price: '',
                unit_marginal_expense_quota: '',
                partner_scheme_rid: '',
                updated_by: '',
                updated_at: '',
                created_by: '',
                created_at: '',
                submission_hierarchy_rid: ''
            },
            btnLoading: false,
            hierarchyOptions: [],
            rules: {
                start_date: [{ required: true, message: '请选择开始时间', trigger: 'blur' }],
                end_date: [{ required: true, message: '请选择结束时间', trigger: 'blur' }],
                unit_invoice_price: [{ required: true, message: '请输入发票单价', trigger: 'blur' }],
                unit_invoice_price: [{ required: true, message: '请输入发票单价', trigger: 'blur' }],
                unit_marginal_expense_quota: [{ required: true, message: '请输入单位限额', trigger: 'blur' }],
                partner_scheme_rid: [{ required: true, message: '请输入合作规划code', trigger: 'blur' }]
            },
            states: [],
            btnTitle: ''
        };
    },
    created() {
        this.type = this.$route.query.type;
        this.rid = this.$route.query.id;
    },
    mounted() {
        // this.getHierarchies();
        this.getPartnerScheme(); //获取合作规划code列表
        if (this.type == 1 || this.type == 5) {
            this.getDetails(); //获取详情
        } else {
            this.ruleForm = {
                code: '',
                partner_rid: '',
                partner_name: '',
                product_rid: '',
                product_name: '',
                product_code: '',
                city_rid: '',
                city_name: '',
                province_rid: '',
                province_name: '',
                feature_code: '',
                start_date: '',
                end_date: '',
                timeliness: '',
                timeliness_label: '',
                approval_status_label: '',
                marginal_expense_provision_rate: '',
                value_added_tax_rate: '',
                demander_rid: '',
                unit_invoice_price: '',
                unit_marginal_expense_quota: '',
                partner_scheme_rid: '',
                updated_by: '',
                updated_at: '',
                created_by: '',
                created_at: '',
                submission_hierarchy_rid: ''
            };
        }
    },
    computed: {
        listSet() {
            return this.states.map((item) => {
                return { value: `${item.rid}`, label: `${item.name}` };
            });
        }
    },
    methods: {
        //获取提交人职位
        // getHierarchies() {
        //     let params = {};
        //     this.$api
        //         .adminHierarchies(params)
        //         .then((res) => {
        //             if (res.code == 0) {
        //                 this.hierarchyOptions = res.data;
        //                 if (res.data.length != 0) {
        //                     this.ruleForm.submission_hierarchy_rid = res.data[0].value;
        //                 }
        //             }
        //         })
        //         .catch((error) => {
                    
        //         });
        // },
        //获取合作规划code列表
        getPartnerScheme() {
            let params = {
                has_all: '1'
            };
            this.$api
                .partnerSchemes(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.partnerSchemeOptions = res.data;
                    }
                })
                .catch((error) => {
                    
                });
        },
        //查看价格控制
        priceClick(rid) {
            this.$router.push({
                path: 'priceControlDetail',
                query: {
                    id: rid
                }
            });
        },
        //查看产品详情
        productClick(rid) {
            this.$router.push({
                path: 'productListDetails',
                query: {
                    id: rid
                }
            });
        },
        //开始时间框联动
        startChange(val) {
            this.ruleForm.start_date = val;
            this.ruleForm.end_date = '';
        },
        //结束时间框联动
        endDate(val) {
            if (val) {
                if (!this.ruleForm.start_date) {
                    this.$message({
                        message: '请先选择开始时间！',
                        type: 'warning'
                    });
                    this.ruleForm.end_date = '';
                } else {
                    let startTime = this.ruleForm.start_date.replace(/-/g, '');
                    let endTime = this.ruleForm.end_date.replace(/-/g, '');
                    if (endTime < startTime) {
                        this.$message({
                            message: '结束时间不能小于开始时间！',
                            type: 'warning'
                        });
                        this.ruleForm.end_date = '';
                    }
                }
            }
        },
        //需方选择框联动
        partnerChange(val) {
            this.ruleForm.demander_rid = val;
        },
        //需方搜索
        remotePartner(query) {
            if (query !== '') {
                this.partnerLoading = true;
                let params = {
                    name: query
                };
                this.$api
                    .searchAccounts(params)
                    .then((res) => {
                        if (res.code == 0) {
                            this.states = res.data;
                            setTimeout(() => {
                                this.partnerLoading = false;
                                this.partnerOptions = this.listSet.filter((item) => {
                                    return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
                                });
                            }, 200);
                        } else {
                            this.partnerOptions = [];
                        }
                    })
                    .catch((error) => {
                        
                    });
            } else {
                this.partnerLoading = false;
                this.partnerOptions = [];
            }
        },
        //取消
        cancel() {
            if (window.history.length <= 1) {
                this.$router.push({ path: '/cooperativePriceList' });
            } else {
                this.$router.go(-1);
            }
        },
        //获取详情
        getDetails() {
            let params = {
                rid: this.rid
            };
            this.$api
                .partnerPriceDetail(params)
                .then((res) => {
                    if (res.code == 0) {
                        res.data.submission_hierarchy_rid = this.ruleForm.submission_hierarchy_rid;
                        this.ruleForm = res.data;
                    }
                })
                .catch((error) => {
                    
                });
        },
        //提交新增/编辑修改
        submitDetailsData(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (this.type == 1) {
                        this.submitEditData(); //修改
                    } else {
                        this.submitAddData(); //新增
                    }
                } else {
                    return false;
                }
            });
        },
        //提交修改
        submitEditData() {
            let params = {
                demander_rid: this.ruleForm.demander_rid ? this.ruleForm.demander_rid : '',
                start_date: this.ruleForm.start_date,
                end_date: this.ruleForm.end_date,
                unit_invoice_price: this.ruleForm.unit_invoice_price,
                unit_marginal_expense_quota: this.ruleForm.unit_marginal_expense_quota,
                partner_scheme_rid: this.ruleForm.partner_scheme_rid,
                rid: this.rid,
                submission_hierarchy_rid: this.ruleForm.submission_hierarchy_rid
            };
            this.btnLoading = true;
            this.$api
                .partnerPriceUpdate(params)
                .then((res) => {
                    this.btnLoading = false;
                    if (res.code == 0) {
                        this.$message({
                            message: '修改成功！',
                            type: 'success'
                        });
                        this.cancel();
                    }
                })
                .catch((error) => {
                    this.btnLoading = false;
                    
                });
        },
        //提交新增
        submitAddData() {
            let params = {
                demander_rid: this.ruleForm.demander_rid ? this.ruleForm.demander_rid : '',
                start_date: this.ruleForm.start_date,
                end_date: this.ruleForm.end_date,
                unit_invoice_price: this.ruleForm.unit_invoice_price,
                unit_marginal_expense_quota: this.ruleForm.unit_marginal_expense_quota,
                partner_scheme_rid: this.ruleForm.partner_scheme_rid,
                submission_hierarchy_rid: this.ruleForm.submission_hierarchy_rid
            };
            this.btnLoading = true;
            this.$api
                .partnerPriceInsert(params)
                .then((res) => {
                    this.btnLoading = false;
                    if (res.code == 0) {
                        this.$message({
                            message: '新增成功！',
                            type: 'success'
                        });
                        this.cancel();
                    }
                })
                .catch((error) => {
                    this.btnLoading = false;
                    
                });
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
</style>